export default __webpack_public_path__ + "./static/favicon-96x96.png";